export const marketTightnessInfoText =
  'A single score combining demand-to-supply ratio, time to fill, and wage pressure, ranked against all other labor markets. A higher score means employers face more competition to hire talent.';

export const demandSupplyRatioRankInfoText =
  'Percentile ranking of the ratio of postings (weighted by expected hires) against the number of profiles. A higher percentile means employers are competing over a smaller pool of available talent.';

export const wagePressureRankInfoText =
  "Percentile ranking of the market's YoY salary growth, measured by the estimated workforce salary. A higher percentile means salaries are climbing faster than other markets, making talent more expensive to hire.";

export const timeToFillRankInfoText =
  'Percentile ranking of how long job postings take to fill. A higher percentile means vacancies stay open longer, signaling a more challenging hiring environment.';
